export default __webpack_public_path__ + "static/media/Tchoupi_Oddities_3781.f2507c89.png";